export const hasBlockType = (value, type) =>
  value.blocks.some(node => node.type == type)

export const isTextSelected = value => {
  const { fragment, selection } = value
  return (
    selection &&
    !selection.isBlurred &&
    !selection.isCollapsed &&
    fragment.text !== ""
  )
}
